import { proxy, useSnapshot } from 'valtio';
import type {
  CollectorActivityFeedFilterArgs,
  CollectorActivityFeedQuery,
} from '@graphql/reactQuery';
import { CollectorActivityFeedTypeFilterOption } from '@graphql/reactQuery';

export type Action = NonNullable<
  CollectorActivityFeedQuery['collectorActivityFeed']
>['edges'][number]['node'];

export const initialFilterArgs: CollectorActivityFeedFilterArgs = {
  types: [CollectorActivityFeedTypeFilterOption.All],
};

type CollectorActivityStateArgs = {
  scrollIndices: Record<string, number | undefined>;
  filter: Record<string, CollectorActivityFeedFilterArgs>;
};

const initialState: CollectorActivityStateArgs = {
  scrollIndices: {},
  filter: {},
};

// Keep track of state per collector
export const CollectorActivityState: CollectorActivityStateArgs = proxy(initialState);

export const useCollectorActivityState = () => useSnapshot(CollectorActivityState);
